import React, { Fragment } from "react";
import "./LinkBox.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink } from "@fortawesome/pro-duotone-svg-icons";

interface Props {
  accessCode: string | undefined;
}

export default function LinkBox(props: Props) {
  const { accessCode } = props;

  return (
    <Fragment>
      <div className="c-link-box d-flex justify-content-center align-items-center p-3 w-100 text-center text-dark">
        {accessCode ? (
          <Fragment>
            <div>
              <FontAwesomeIcon icon={faLink} className="mr-2" />
              d20.link/{accessCode}
            </div>
          </Fragment>
        ) : null}
      </div>
    </Fragment>
  );
}
